module.exports = __webpack_public_path__ + "media/yes0.a34cf437.mp3";